import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const recetarios = [{
  number: 1,
  title: 'Recetario Mixología con Café',
  recipes: '50 recetas',
  image: 'https://cdn.magicpatterns.com/uploads/rvFRKz8R1fLaAvRtgkR9Xf/image.png'
}, {
  number: 2,
  title: 'Recetario Mixología con Té',
  recipes: '40 recetas',
  image: 'https://cdn.magicpatterns.com/uploads/qieqhhxgyave4fiBahx14C/image.png'
}, {
  number: 3,
  title: 'Recetario de Matcha',
  recipes: '30 recetas',
  image: 'https://cdn.magicpatterns.com/uploads/tBuqZjxuBcyLZexYsWGxT9/image.png'
}, {
  number: 4,
  title: 'Recetario de Postres',
  recipes: '50 recetas',
  image: 'https://cdn.magicpatterns.com/uploads/sH3knt6YPNoGDn1swKteND/image.png'
}, {
  number: 5,
  title: 'Recetario de Galletas',
  recipes: '25 recetas',
  image: 'https://cdn.magicpatterns.com/uploads/suWkKtSyMF4AjiUrVfDdTQ/image.png'
}, {
  number: 6,
  title: 'Recetario de Barritas',
  recipes: '25 recetas',
  image: 'https://cdn.magicpatterns.com/uploads/7F4BkBBq7xHtFQXcDdtqPa/image.png'
}, {
  number: 7,
  title: 'Recetario de Batidos',
  recipes: '30 recetas',
  image: 'https://cdn.magicpatterns.com/uploads/e8NaNNvRer4q3BUWzZRLtz/image.png'
}, {
  number: 8,
  title: 'Recetario de Jarabes',
  recipes: '10 recetas',
  image: 'https://cdn.magicpatterns.com/uploads/co5zhUfTL7o88X3Ha6zx8D/image.png'
}];
const bonusExclusivos = [{
  number: 1,
  title: 'Mitos y Verdades del Café',
  description: 'Descubre qué es mito y qué es verdad sobre tu bebida favorita, con datos reales y cultura cafetera.',
  image: 'https://cdn.magicpatterns.com/uploads/aAE5GZSjVFRLacdC1yMojL/image.png'
}, {
  number: 2,
  title: 'Guía de Métodos de Extracción',
  description: 'Aprende a preparar café perfecto en casa con cualquier cafetera y domina los secretos del barista casero.',
  image: 'https://cdn.magicpatterns.com/uploads/edkjKdGm88yG8qgjEnY161/image.png'
}, {
  number: 3,
  title: 'Guía Emprendedora: Mi Cafetería',
  description: 'Convierte tu pasión por el café en un negocio rentable y con propósito.',
  image: 'https://cdn.magicpatterns.com/uploads/16RVAGy2gDuVjFmYJ6eoSw/image.png'
}];
export function BonusSection() {
  return <section className="py-8 bg-cream" data-id="element-8">
      <div className="max-w-4xl mx-auto px-6" data-id="element-9">
        {/* Header - Recetarios */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-10">
          <h2 className="text-xl md:text-2xl font-serif text-coffee-dark" data-id="element-11">
            Además{' '}
            <span className="text-coffee-light font-semibold" data-id="element-12">incluye</span>{' '}
            estos{' '}
            <span className="text-coffee-light font-semibold" data-id="element-13">
              bonus de regalo
            </span>
          </h2>
        </motion.div>

        {/* Recetarios Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-8" data-id="element-14">
          {recetarios.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-lg p-3 text-center shadow-sm" data-id="element-15">
              <div className="text-coffee-light text-[10px] font-semibold mb-1 flex items-center justify-center gap-1" data-id="element-16">
                BONUS {item.number} <Gift className="w-2.5 h-2.5" data-id="element-17" />
              </div>
              <div className="aspect-[3/4] bg-coffee-light/10 rounded mb-2 flex items-center justify-center overflow-hidden" data-id="element-18">
                {item.image ? <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-19" /> : <span className="text-coffee/30 text-[10px]" data-id="element-20">Imagen</span>}
              </div>
              <h3 className="text-[10px] font-bold text-coffee-dark uppercase leading-tight mb-0.5" data-id="element-21">
                {item.title}
              </h3>
              <p className="text-[9px] text-coffee/50" data-id="element-22">{item.recipes}</p>
            </motion.div>)}
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-coffee/10 mb-8" data-id="element-23"></div>

        {/* Header - Bonus Exclusivos */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-24">
          <h2 className="text-xl md:text-2xl font-serif text-coffee-dark" data-id="element-25">
            Solo por{' '}
            <span className="text-coffee-light font-semibold" data-id="element-26">hoy</span>,
            llévate estos{' '}
            <span className="text-coffee-light font-semibold" data-id="element-27">
              bonus exclusivos
            </span>
          </h2>
        </motion.div>

        {/* Bonus Exclusivos List */}
        <div className="space-y-3" data-id="element-28">
          {bonusExclusivos.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex gap-3 bg-white rounded-lg p-3 shadow-sm" data-id="element-29">
              {/* Image */}
              <div className="shrink-0 w-16 h-24 bg-coffee-light/10 rounded flex items-center justify-center overflow-hidden" data-id="element-30">
                {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-31" /> : <span className="text-coffee/30 text-[9px]" data-id="element-32">Imagen</span>}
              </div>

              {/* Content */}
              <div className="flex-1" data-id="element-33">
                <div className="text-coffee-light text-[10px] font-semibold mb-1 flex items-center gap-1" data-id="element-34">
                  BONUS EXCLUSIVO {bonus.number}{' '}
                  <Gift className="w-2.5 h-2.5" data-id="element-35" />
                </div>
                <h3 className="text-xs font-bold text-coffee-dark uppercase mb-1" data-id="element-36">
                  {bonus.title}
                </h3>
                <p className="text-[11px] text-coffee/70 leading-relaxed" data-id="element-37">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}